'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadow = exports.getOutlineButtonColor = exports.getButtonTextColor = exports.getButtonMinWidth = exports.getButtonHeight = exports.getButtonGradientColor = exports.getButtonColor = exports.getButtonFontSize = exports.getButtonBorderRadius = exports.getTextColor = exports.getFontWeight = exports.getFontSize = exports.getFontFamily = exports.getBorderColor = exports.getBackgroundColor = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.getThemePropsComposer = getThemePropsComposer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getThemePropsComposer() {
  var propName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'colors';
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var defaultValueOverride = arguments[1];

    var _ref$theme = _ref.theme,
        theme = _ref$theme === undefined ? {} : _ref$theme,
        _objectWithoutPropert = (0, _objectWithoutProperties3.default)(_ref, ['theme']),
        _objectWithoutPropert2 = _objectWithoutPropert,
        props = _objectWithoutPropert2 === undefined ? {} : _objectWithoutPropert2;

    var propGroup = theme[propName] || {};
    var foundProp = propGroup && (0, _keys2.default)(propGroup).find(function (prop) {
      return props[prop];
    });
    return foundProp ? propGroup[foundProp] : defaultValueOverride || propGroup.default || defaultValue;
  };
}

var getBackgroundColor = exports.getBackgroundColor = getThemePropsComposer('backgroundColors', 'inherit');
var getBorderColor = exports.getBorderColor = getThemePropsComposer('borderColors', 'inherit');
var getFontFamily = exports.getFontFamily = getThemePropsComposer('fontFamily', 'inherit');
var getFontSize = exports.getFontSize = getThemePropsComposer('fontSizes', 'inherit');
var getFontWeight = exports.getFontWeight = getThemePropsComposer('fontWeights', 'inherit');
var getTextColor = exports.getTextColor = getThemePropsComposer('textColors', 'inherit');

var getButtonBorderRadius = exports.getButtonBorderRadius = getThemePropsComposer('buttonBorderRadius');
var getButtonFontSize = exports.getButtonFontSize = getThemePropsComposer('buttonFontSizes');
var getButtonColor = exports.getButtonColor = getThemePropsComposer('buttonColors');
var getButtonGradientColor = exports.getButtonGradientColor = getThemePropsComposer('buttonGradientColors');
var getButtonHeight = exports.getButtonHeight = getThemePropsComposer('buttonHeights');
var getButtonMinWidth = exports.getButtonMinWidth = getThemePropsComposer('buttonMinWidths');
var getButtonTextColor = exports.getButtonTextColor = getThemePropsComposer('buttonTextColors');
var getOutlineButtonColor = exports.getOutlineButtonColor = getThemePropsComposer('outlineButtonColors');

var getShadow = exports.getShadow = getThemePropsComposer('shadows');

exports.default = getThemePropsComposer();
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../theme-props/lib/index.js
// module id = 21
// module chunks = 0